import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
import './LanguageSwitcher.css';

const FlagIT = () => (
  <svg viewBox="0 0 640 480" className="lang-switcher__flag">
    <rect width="213.3" height="480" fill="#009246" />
    <rect x="213.3" width="213.4" height="480" fill="#fff" />
    <rect x="426.7" width="213.3" height="480" fill="#ce2b37" />
  </svg>
);

const FlagEN = () => (
  <svg viewBox="0 0 640 480" className="lang-switcher__flag">
    <rect width="640" height="480" fill="#012169" />
    <path d="M75 0l244 181L562 0h78v62L400 241l240 178v61h-80L320 302 81 480H0v-60l239-178L0 64V0h75z" fill="#fff" />
    <path d="M424 281l216 159v40L369 281h55zm-184 20l6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z" fill="#C8102E" />
    <path d="M241 0v480h160V0H241zM0 160v160h640V160H0z" fill="#fff" />
    <path d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z" fill="#C8102E" />
  </svg>
);

const LanguageSwitcher = () => {
  const { lang, toggleLang } = useLanguage();

  return (
    <motion.button
      className="lang-switcher"
      onClick={toggleLang}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      aria-label={lang === 'it' ? 'Switch to English' : 'Passa all\'italiano'}
      title={lang === 'it' ? 'English' : 'Italiano'}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={lang}
          className="lang-switcher__inner"
          initial={{ rotateY: 90, opacity: 0 }}
          animate={{ rotateY: 0, opacity: 1 }}
          exit={{ rotateY: -90, opacity: 0 }}
          transition={{ duration: 0.25, ease: 'easeInOut' }}
        >
          {lang === 'it' ? <FlagIT /> : <FlagEN />}
          <span className="lang-switcher__label">{lang.toUpperCase()}</span>
        </motion.div>
      </AnimatePresence>
    </motion.button>
  );
};

export default LanguageSwitcher;
